<template>
    <div class="calendar-cell relative" :class="absences.length > 0 && !extended ? classCellAbsence : null">
        <template v-if="extended">
            <div class="w-full px-2 pb-1 pt-4" style="height: calc(100% - 28px);">
                <template v-if="absences.length > 0">
                    <div v-for="absence in absences" :key="absence.id"
                         class="planningable planningable-absence" :class="'bg-absence-' + absence.absence_type_id">
                        <span class="font-medium text-black">Absence prévue : {{ absence.absence_type.name }}</span>
                    </div>
                </template>
                <template v-for="(planningable, index) in plannings">
                    <div v-if="isIntervention(planningable)" class="planningable" :key="planningable.id"
                        :class="{'planningable-with-sector': showSector(index, planningable)}">
                        <div v-if="showSector(index, planningable)">
                            <span class="font-extrabold underline">{{ site(planningable.intervention).sector.name }}</span>
                        </div>
                        <div class="planningable-intervention" :class="{'selected': interventionIsSelected(planningable)}">
                            <div class="mr-1 mt-0.5 float-left" v-if="site(planningable.intervention).id">
                                <div class="square-tooltip cursor-pointer" :class="statusIntervention(planningable.intervention).color"
                                    @mousedown="goToRoute($event, 'Intervention Details', { id: planningable.intervention.id })">
                                    <span v-if="planningable.intervention.planning_intervention_prevision_id"
                                        class="font-medium leading-none">
                                        {{ dateInterventionPlan(planningable.intervention).month }}
                                    </span>
                                </div>
                                <md-tooltip md-direction="top" style="min-width: max-content !important;">
                                    <b>{{ site(planningable.intervention).name }}</b>
                                    <p class="mb-0">{{ site(planningable.intervention).address.addresses }}</p>
                                    <p class="mb-0">{{ site(planningable.intervention).address.zip_code + ' - ' + site(planningable.intervention).address.city }}</p>
                                    <md-divider class="my-1 -mx-2.5"></md-divider>
                                    <p class="mb-0">
                                        Type d'intervention :
                                        <span class="font-medium">{{ planningable.intervention.intervention_type.name }}</span>
                                    </p>
                                    <p class="mb-0" v-if="planningable.intervention.planning_intervention_prevision_id">
                                        Date d'intervention :
                                        <span class="font-medium">
                                            {{ dateInterventionPlan(planningable.intervention, true).month + '/' + dateInterventionPlan(planningable.intervention).year }}
                                        </span>
                                    </p>
                                    <p class="mb-0">
                                        État de l'intervention :
                                        <span class="font-medium">{{ statusIntervention(planningable.intervention).text }}</span>
                                    </p>
                                    <p class="mb-0">
                                        Catégorie de l'intervention :
                                        <span class="font-medium">{{ planningable.intervention.category.name }}</span>
                                    </p>
                                </md-tooltip>
                            </div>
                            <div class="flex justify-between items-center">
                                <div :style="{ maxWidth: `calc(100% - ${planningable.intervention.status_id === 6 ? '0px' : '20px' }` }">
                                    <span>
                                        {{ schedule(planningable).start + ' / ' + schedule(planningable).end }}
                                    </span>
                                    -
                                    <span class="hover:underline cursor-pointer" @click="openModal(planningable)">
                                        {{ site(planningable.intervention).name }}
                                    </span>
                                    <span v-if="site(planningable.intervention).is_baiting_unpermanent" class="ml-0.5">
                                        <template v-if="site(planningable.intervention).is_smart">(S)</template>
                                        <template v-else>(12)</template>
                                    </span>
                                    <template v-if="interventionIsPrevision(planningable.intervention)
                                        && interventionDurationNotSamePrevisionDuration(planningable.intervention)
                                           && !interventionDuration(planningable.intervention).isValid">
                                        <span class="ml-0.5 round-tooltip cursor-pointer" @click="validateDurationIntervention(interventionDuration(planningable.intervention).interventionId)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                            <md-tooltip md-direction="top">
                                                <div>
                                                    <div>Durée contrat : {{ interventionDuration(planningable.intervention).durationPlan }}m</div>
                                                    <div>Durée planifiée : {{ interventionDuration(planningable.intervention).duration }}m</div>
                                                    <p class="mb-0 font-semibold italic">Cliquez pour enlever l'alerte</p>
                                                </div>
                                            </md-tooltip>
                                        </span>
                                    </template>
                                </div>
                                <div class="case-select" v-if="planningable.intervention.status_id !== 6">
                                    <md-checkbox v-model="transfer.interventions" :value="planningable.id"
                                                 :disabled="(transferFrom.date !== '' && transferFrom.date !== day.date)"
                                                 @change="updateTransferInterventions">
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                        <div v-if="travelTime(index, planningable, index + 1).show" class="mt-0.5" style="padding: 0 0.25rem;">
                            <span class="font-medium">Trajet : {{ travelTime(index, planningable, index + 1).time }}</span>
                        </div>
                    </div>
                    <template v-else-if="isElement(planningable)">
                        <div v-if="planningable.element.is_pause" :key="planningable.id"
                             class="planningable planningable-element planningable-lunch">
                            <div class="flex items-center justify-between">
                                <div class="font-medium pr-1.5">
                                    <span>{{ planningable.element.text }}</span>
                                    <span class="ml-1">- {{ durationBetweenDates(planningable.start_date, planningable.end_date) }}</span>
                                </div>
                                <div class="-mr-1">
                                    <md-button class="md-icon-button md-delete md-small-icon my-0"
                                               @click="deleteElement(planningable.id)">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                                    </md-button>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="planningable.element.is_deplacement" :key="planningable.id"
                             class="planningable planningable-element planningable-deplacement">
                            <div class="flex items-center justify-between">
                                <div class="font-medium pr-1.5">
                                    <span>{{ planningable.element.text }}</span>
                                    <span class="ml-1">- {{ durationBetweenDates(planningable.start_date, planningable.end_date) }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else :key="planningable.id" class="planningable planningable-element">
                            <div class="flex items-center justify-between">
                                <div class="font-medium pr-1.5">
                                    <span>{{ schedule(planningable).start + ' / ' + schedule(planningable).end }}</span>
                                    <span class="ml-1">- {{ planningable.element.text }}</span>
                                </div>
                                <div class="-mr-1">
                                    <md-button class="md-icon-button md-delete md-small-icon my-0"
                                               @click="deleteElement(planningable.id)">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else-if="planningable.absence_type_id" :key="planningable.id"
                         class="planningable planningable-element planningable-absence">
                        <div class="flex items-center justify-between">
                            <div class="font-medium">
                                <span>{{ schedule(planningable).start + ' / ' + schedule(planningable).end }}</span>
                                <span class="ml-1">- Réunion {{ planningable.comment ? ' : ' + planningable.comment : '' }}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="planningable planningable-total-time" v-if="totalDayTime.total">
                    <span class="text-right font-medium">Temps total : {{ totalDayTime.total }}</span>
                </div>
                <md-dialog v-if="modal.interventionId" :md-active.sync="modal.show" class="dialog-overflow dialog-calendar">
                    <md-content class="px-3 mt-1">
                        <calendar-modal-intervention :interventionId="modal.interventionId"></calendar-modal-intervention>
                    </md-content>
                </md-dialog>
            </div>
        </template>
        <template v-else>
            <div class="w-full h-full flex items-center justify-center">
                <div class="pt-6 pb-6">
                    <div class="font-medium leading-4" v-if="countInterventions === 0 && countReunions > 0">
                        {{ countReunions + ' réunion' + (countReunions > 1 ? 's' : '') }}
                    </div>
                    <div class="font-medium leading-4" v-else-if="countInterventions === 0 && countReunions === 0 && countElements > 0">
                        {{ countElements + ' temps divers' }}
                    </div>
                    <div class="font-medium leading-4" v-else>
                        {{ (countInterventions > 0 ? countInterventions : 'Aucune') + ' intervention' + (countInterventions > 1 ? 's' : '') }}
                    </div>
                    <div class="leading-4 mt-1" v-if="totalDayTime.total">
                        {{ totalDayTime.schedules ? totalDayTime.schedules.start + ' à ' + totalDayTime.schedules.end + ' (' + totalDayTime.total + ')' : '' }}
                    </div>
                </div>
            </div>
        </template>
        <div v-if="isConflict" class="absolute cell-conflict">
            <div class="flex items-center">
                <font-awesome-icon class="md-icon text-danger mr-1" :icon="['fa', 'exclamation-circle']" />
                <span class="text-xs text-danger font-medium">Intervention(s) en conflit</span>
            </div>
        </div>
        <div v-if="absences.length > 0 && !extended" class="absolute cell-absence">
            <span class="text-xs leading-none font-medium">Absence prévue : {{ absencesPrevision }}</span>
        </div>
        <div class="absolute cell-date">
            <span class="text-xs leading-none">{{ date }}</span>
        </div>
        <div class="absolute cell-actions" v-if="extended">
            <div class="flex items-center">
                <div class="mr-1">
                    <md-button class="md-icon-button md-warning md-small-icon md-rounded-icon my-0"
                               @click="openEditDayPanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </md-button>
                    <md-tooltip md-direction="top">Modifier</md-tooltip>
                </div>
                <div class="mr-1">
                    <md-button class="md-icon-button md-success md-small-icon md-rounded-icon my-0"
                        @click="openTransferInterventionsPanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'exchange-alt']" />
                    </md-button>
                    <md-tooltip md-direction="top">Transfert</md-tooltip>
                </div>
                <div class="mr-1">
                    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-info"
                        @click="openAddElementPanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                    </md-button>
                    <md-tooltip md-direction="top">Ajouter un temps divers</md-tooltip>
                </div>
                <div class="mr-1">
                    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0"
                        @click="openAddAbsencePanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'male']" />
                    </md-button>
                    <md-tooltip md-direction="top">Ajouter une absence</md-tooltip>
                </div>
	            <div>
		            <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success"
		                @click="refreshDay">
			            <font-awesome-icon class="md-icon" :icon="['fa', 'sync-alt']" :class="{'animate-spin': refreshing}" />
		            </md-button>
		            <md-tooltip md-direction="top">Actualiser la journée</md-tooltip>
	            </div>
            </div>
        </div>
        <div class="absolute cell-move-interventions" v-if="extended && transfer.interventions.length > 0
            && (transferFrom.date !== day.date || transferFrom.technicianId !== technician.id)">
            <div>
                <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success" @click="transferSelectedInterventions">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'angle-double-right']" />
                </md-button>
                <md-tooltip md-direction="top">Déplacer les interventions</md-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarModalIntervention from "@/pages/Planning/Calendar/components/calendar/CalendarModalIntervention";
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin';
import routerMixin from '@/mixins/router-mixin';

import { mapState } from "vuex";

export default {
    name: "CalendarCell",
    components: {
        CalendarModalIntervention
    },
    mixins: [dateTimeFormattingMixin, routerMixin],
    props: {
        plannings: Array,
        extended: Boolean,
        isConflict: Boolean,
        day: Object,
        absences: Array,
        technician: Object
    },
    data() {
        return {
            modal: {
                show: false,
                interventionId: null
            },
            transfer: {
                interventions: []
            },
	        refreshing: false
        }
    },
    computed: {
        date() {
            return this.$moment(this.day.date).format('DD/MM/YYYY') + ' - S' + this.day.weekNumber
        },
        countInterventions() {
            return this.plannings.filter(planningable => {
                return !!this.isIntervention(planningable)
            }).length
        },
        countReunions() {
            return this.plannings.filter(planningable => {
                return !this.isIntervention(planningable) && !this.isElement(planningable)
            }).length
        },
        countElements() {
            return this.plannings.filter(planningable => {
                return !!this.isElement(planningable)
            }).length
        },
        totalDayTime() {
            let total = 0
            this.plannings.map((planningable) => {
                if(planningable.end_date) {
                    total += (this.$moment.duration(this.$moment(planningable.end_date).diff(this.$moment(planningable.start_date)))).asMinutes()
                } else if(planningable.date_end) {
                    total += (this.$moment.duration(this.$moment(planningable.date_end).diff(this.$moment(planningable.date_start)))).asMinutes()
                }
            })

            let firstElement = this.plannings.find(planningable => this.$moment(planningable.start_date).format('HH') !== '00') ?? {}
            let lastElement = this.plannings.find((planningable, index) =>
                (index === (this.plannings.length - 1) && (planningable.end_date || planningable.date_end))
            )

            return {
                total: total > 0 ? this.hoursAndMinutes(total) : null,
                schedules: this.plannings.length > 0 ? {
                    start: this.$moment(firstElement.start_date).format('HH:mm'),
                    end: lastElement.end_date ? this.$moment(lastElement.end_date).format('HH:mm') : this.$moment(lastElement.date_end).format('HH:mm'),
                } : null
            }
        },
        classCellAbsence() {
            const lastIndex = this.absences.length - 1
            return {
                'cell-bg cell-bg-gray': this.absences[lastIndex].absence_type_id === 1,
                'cell-bg cell-bg-blue': this.absences[lastIndex].absence_type_id === 2,
                'cell-bg cell-bg-orange': this.absences[lastIndex].absence_type_id === 3,
                'cell-bg cell-bg-green': this.absences[lastIndex].absence_type_id === 4,
                'cell-bg cell-bg-red': this.absences[lastIndex].absence_type_id === 5,
                'cell-bg cell-bg-purple': this.absences[lastIndex].absence_type_id === 6,
                'cell-bg cell-bg-pink': this.absences[lastIndex].absence_type_id === 7,
            }
        },
        absencesPrevision() {
            const text = this.absences.map(absence => { return absence.absence_type.name }).join(', ')
            return text.length > 20 ? text.substring(0, 20) + '...' : text
        },
        ...mapState({
            transferFrom: state => state.calendarTransfer.from,
	        transferInterventions: state => state.calendarTransfer.interventions
        })
    },
    methods: {
        isIntervention(planningable) {
            return planningable && planningable.planningable_type ? planningable.planningable_type.includes('Intervention') && planningable.intervention !== null : false
        },
        isElement(planningable) {
            return planningable && planningable.planningable_type ? planningable.planningable_type.includes('Element') && planningable.element !== null : false
        },
        interventionIsPrevision(intervention) {
            return !!intervention.planning_intervention_prevision_id
        },
        interventionDurationNotSamePrevisionDuration(intervention) {
            return intervention.duration !== intervention.planning_intervention_prevision.duration
        },
        interventionDuration(intervention) {
            return {
                durationPlan: intervention.planning_intervention_prevision.duration,
                duration: intervention.duration,
                isValid: intervention.is_duration_valid,
                interventionId: intervention.id
            }
        },
        searchPreviousIntervention(indexCurrentIntervention) {
            let index = 1
            let previousPlanning = this.plannings[indexCurrentIntervention - index]
            while(!previousPlanning.intervention && (indexCurrentIntervention - index >= 0)) {
                index++
                previousPlanning = this.plannings[indexCurrentIntervention - index]
            }
            return previousPlanning
        },
        showSector(index, planningable) {
            return ((!this.plannings[(index - 1)] || !this.plannings[(index - 1)].intervention) ||
                (this.plannings[(index - 1)]
                    && !this.sameSector(this.searchPreviousIntervention(index).intervention, planningable.intervention)
                )
            )
        },
        sameSector(previousIntervention, currentIntervention) {
            let previousSector = this.site(previousIntervention).sector
            let currentSector = this.site(currentIntervention).sector
            if(!previousSector || !currentSector) {
                return false
            } else {
                return previousSector.id === currentSector.id
            }
        },
        site(intervention) {
            let site = { name: 'Pas de site', id: '', address: {}, sector: {} }
            if(intervention.site) {
                site = intervention.site ?? { id: null, name: 'Pas de site', address: {}, sector: {} }
            } else {
                let contract = intervention?.planning_intervention_prevision?.planning_intervention_group?.planning_intervention?.contract
                site = contract.site ?? { id: null, name: 'Pas de site', address: {}, sector: {} }
            }
            site.sector = site.sector ?? { name: 'Pas de secteur' }
            return site
        },
        sameSite(nextPlanningable, currentIntervention) {
            if(nextPlanningable.intervention) {
                const nextSite = this.site(nextPlanningable.intervention)
                const currentSite = this.site(currentIntervention)
                if(!nextSite || !currentSite) {
                    return false
                } else {
                    return nextSite.id === currentSite.id
                }
            } else {
                return false
            }
        },
        travelTime(indexCurrentPlanningable, currentPlanningable, indexNextPlanningable) {
            let nextIndex = indexNextPlanningable
            let nextPlanningable = this.plannings[nextIndex]
            while(nextPlanningable && !nextPlanningable.intervention && (nextIndex <= this.plannings.length)) {
                nextPlanningable = this.plannings[nextIndex]
                nextIndex++
            }
            if(nextPlanningable) {
                if(!this.sameSite(nextPlanningable, currentPlanningable.intervention)) {
                    const duration = (this.$moment.duration(this.$moment(nextPlanningable.start_date).diff(this.$moment(currentPlanningable.end_date)))).asMinutes()
                    const time = this.hoursAndMinutes(duration)
                    return { show: true, time: time.includes('-') ? 'Invalide' : time }
                } else {
                    return { show: false, time: '' }
                }
            } else {
                return { show: false, time: '' }
            }
        },
        schedule(planningable) {
            const startDate = planningable.start_date ?? planningable.date_start
            const endDate = planningable.end_date ?? planningable.date_end
            return  {
                start: this.$moment(startDate).format('HH:mm'),
                end: this.$moment(endDate).format('HH:mm')
            }
        },
        dateInterventionPlan(intervention, format = false) {
            let month = intervention.planning_intervention_prevision.month + 1
            if(format) {
                month = month.toString().length === 1 ? '0' + month : month
            }
            return {
                year: this.$moment(this.day.date).format('YYYY'),
                month: month
            }
        },
        statusIntervention(intervention) {
            let status = { text: intervention.status.name, color: '' }
            switch (intervention.status_id) {
                case 1:
                    status.color = 'danger'
                    break
                case 2:
                    status.color = 'warning'
                    break
                case 3:
                    status.color = 'yellow'
                    break
                case 4:
                    status.color = 'success'
                    break
                default:
                    status.color = 'black'
                    break
            }
            return status
        },
        interventionIsSelected(planningable) {
            return !!this.transfer.interventions.find(inter => inter === planningable.id)
        },
        openModal(planningable) {
            this.modal = {
                show: true,
                interventionId: planningable.intervention.id
            }
        },
        async validateDurationIntervention(interventionId) {
            try {
                const { data } = await this.$store.dispatch('calendar/validateDurationIntervention', {
                    intervention_id: interventionId,
                    weekNumber: this.day.weekNumber,
                    day: this.$moment(this.day.date).format('YYYY-MM-DD'),
                    technician_id: this.technician.id
                })
                this.$emit('update-cell', data)
            } catch (e) {
            }
        },
        async deleteElement(planningableId) {
            try {
                const { data } = await this.$store.dispatch('calendar/deleteElement', {
                    planningId: planningableId,
                    weekNumber: this.day.weekNumber,
                    day: this.$moment(this.day.date).format('YYYY-MM-DD'),
                    technician_id: this.technician.id
                })
                this.$emit('update-cell', data)
            } catch (e) {
            }
        },
        openEditDayPanel() {
            bus.$emit('open-calendar-panel', {
                type: 'edit-day',
                data: {
                    day: this.day,
                    plannings: this.plannings.filter(planningable => { return !!this.isIntervention(planningable) && planningable.intervention }),
                    isConflict: this.isConflict,
                    technician: this.technician
                }
            })
        },
        openAddElementPanel() {
            bus.$emit('open-calendar-panel', {
                type: 'add-element',
                data: {
                    day: this.day,
                    technician: this.technician
                }
            })
        },
        openAddAbsencePanel() {
            bus.$emit('open-calendar-panel', {
                type: 'add-absence',
                data: {
                    day: this.day,
                    technician: this.technician
                }
            })
        },
        openTransferInterventionsPanel() {
            bus.$emit('open-calendar-panel', {
                type: 'transfer-interventions',
                data: {
                    day: this.day,
                    plannings: this.plannings.filter(planningable => { return !!this.isIntervention(planningable) && planningable.intervention }),
                    isConflict: this.isConflict,
                    technician: this.technician
                }
            })
        },
	    async refreshDay() {
			try {
				this.refreshing = true
				const { data } = await this.$store.dispatch('calendar/refreshDay', {
					technician_id: this.technician.id,
					date: this.day.date,
					weekNumber: this.day.weekNumber
				})
				await this.$store.dispatch('alerts/success', 'Journée actualisée')
				this.$emit('update-cell', data)
				this.refreshing = false
			} catch (e) {}
	    },
        async transferSelectedInterventions() {
            try {
                const { data } = await this.$store.dispatch('calendar/transferSelectedInterventions', {
                    from: {
                        date: this.transferFrom.date,
                        weekNumber: this.transferFrom.weekNumber,
                        technician_id: this.transferFrom.technicianId,
                    },
                    to: {
                        date: this.day.date,
                        weekNumber: this.day.weekNumber,
                        technician_id: this.technician.id
                    },
                    plannings: this.transfer.interventions
                })
                await this.$store.dispatch('alerts/success', 'Transfert effectué')
                await this.$store.dispatch('calendarTransfer/clearInterventions')
                this.transfer.interventions = []
                this.$emit('update-cell', data)
            } catch (e) {
            }
        },
        updateTransferInterventions() {
            this.$store.dispatch('calendarTransfer/toggleCheckInterventions', {
                interventions: this.transfer.interventions,
                day: {
                    date: this.day.date,
                    weekNumber: this.day.weekNumber
                },
                technicianId: this.technician.id
            })
        }
    },
    mounted() {
        this.transfer.interventions = this.$store.getters["calendarTransfer/interventions"]
    },
	watch: {
		transferInterventions(newVal) {
			this.transfer.interventions = newVal
		}
	}
}
</script>

<style scoped lang="scss">
.square-tooltip {
    width: 13px;
    height: 13px;
    border-radius: 3px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    &.danger {
        background-color: $brand-primary;
    }

    &.success {
        background-color: $brand-success;
    }

    &.warning {
        background-color: $brand-warning;
    }

    &.yellow {
        background-color: $yellow-A700;
    }

    &.black {
        background-color: $black;
    }

    span {
        font-size: .6rem;
        line-height: .9rem;
    }
}

.round-tooltip {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: $brand-danger;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .md-icon {
        font-size: .5rem !important;
        min-width: .5rem !important;
        height: .5rem !important;
        color: #FFFFFF;
    }
}

.md-delete {
    background-color: rgba(200, 200, 200, 0.2) !important;

    &:hover {
        background-color: rgba(200, 200, 200, 0.5) !important;
    }
}
</style>
